import dayjs from 'dayjs';

const TIME_FORMAT_24H = 'HH:mm';

/**
 * Converts a date to a string in 24-hour format.
 *
 * @param date - The date to convert, or null if no date is provided.
 * @returns A string representation of the time in 24-hour format, or an empty string if no date is provided.
 */
export const getTimeIn24H = (date?: Date | string | null) => {
  return date ? dayjs(date).format(TIME_FORMAT_24H) : '';
};

/**
 * Converts a number of seconds to a string in the format "MM:SS".
 *
 * @param seconds - The number of seconds to convert.
 * @returns A string representation of the time in the format "MM:SS", with a negative sign if the input was negative.
 */
export const secondsToTime = (seconds: number) => {
  const secondsAbs = Math.abs(seconds);
  const minutes = Math.floor(secondsAbs / 60)
    .toString()
    .padStart(2, '0');
  const secString = (secondsAbs % 60).toString().padStart(2, '0');
  const result = `${minutes}:${secString}`;
  return seconds < 0 ? `-${result}` : result;
};
